import * as __typia_transform__randomPattern from "typia/lib/internal/_randomPattern";
import typia, { type tags } from 'typia';
import type { ArdoqId } from '@ardoq/api-types';
export type DraftId = ArdoqId & tags.Pattern<'^[0-9a-f]{24}$'>;
export const createDraftId = (() => { let _generator: Partial<import("typia").IRandomGenerator> | undefined; return (generator?: Partial<import("typia").IRandomGenerator>): import("typia").Resolved<DraftId> => {
    _generator = generator;
    return (_generator?.pattern ?? __typia_transform__randomPattern._randomPattern)(new RegExp("^[0-9a-f]{24}$"));
}; })();
export const isDraftId = (() => { return (input: any): input is DraftId => "string" === typeof input && RegExp("^[0-9a-f]{24}$").test(input); })();
